var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadAndShow',{attrs:{"uuid":_vm.uuid}})
}
var staticRenderFns = []

export { render, staticRenderFns }